// frontend/src/components/ReviewsCertifications/index.jsx
import React from "react";
import ReportFilterMenu from "../Reports/Timps/reportFilterMenu";
//import ReviewsCertificationsReports from "./ReviewsCertificationsReports/ReviewsCertificationsReports";
import OOSReview from "./OOS/OOSReview";

import { withRouter } from "react-router-dom";
import { curdActions } from "../../reduxCURD/actions";
import { CRUDFunction } from "../../reduxCURD/container";
import { getGroupReportLookup } from "../../reduxRelated/actions/groupReportActions";
import SpinnerLoader from "../Common/SpinnerLoader";
import BlueCardCertification from "./BlueCardsCertification/BlueCardCertification";
import TestsReviewCertification from "./TestsReviewCertification";
import { getAllUsersList } from "../../reduxRelated/actions/userActions";
const reportTabs = [
  { title: "Inspection Reports", name: "RCR", reportId: "R0" },
  { title: "Out of use", name: "OOS", reportId: "R1" },
  { title: "Blue Card", name: "BLC", reportId: "R2" },
];

class ReviewsCertificationsWrapper extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      selectedReport: reportTabs[0],
      spinnerLoading: false,
    };
    this.handleTabsClick = this.handleTabsClick.bind(this);
  }
  componentDidMount() {
    this.props.getApplicationlookupss(["blueCardSections"]);
  }

  componentDidUpdate(prevProps) {
    if (
      this.props.applicationlookupsActionType === "APPLICATIONLOOKUPSS_READ_REQUEST" &&
      this.props.applicationlookupsActionType !== prevProps.applicationlookupsActionType
    ) {
      this.setState({ spinnerLoading: true });
    }
    if (
      this.props.applicationlookupsActionType === "APPLICATIONLOOKUPSS_READ_SUCCESS" &&
      this.props.applicationlookupsActionType !== prevProps.applicationlookupsActionType
    ) {
      this.props.getAllUsersList();
    }

    if (
      this.props.applicationlookupsActionType === "APPLICATIONLOOKUPSS_READ_FAILURE" &&
      this.props.applicationlookupsActionType !== prevProps.applicationlookupsActionType
    ) {
      this.setState({ spinnerLoading: false });
    }

    if (this.props.userActionType !== prevProps.userActionType && this.props.userActionType === "ALL_USER_LIST_REQUEST") {
      this.setState({
        spinnerLoading: true,
      });
    }
    if (this.props.userActionType !== prevProps.userActionType && this.props.userActionType === "ALL_USER_LIST_SUCCESS") {
      this.setState({
        spinnerLoading: false,
      });
    }

    if (this.props.userActionType !== prevProps.userActionType && this.props.userActionType === "ALL_USER_LIST_FAILURE") {
      this.setState({
        spinnerLoading: false,
      });
    }
  }

  handleTabsClick(name) {
    const rep = reportTabs.find((r) => r.name === name);
    if (!rep) return;
    this.setState({ selectedReport: rep });
  }

  render() {
    const { selectedReport } = this.state;
    return (
      <div className="mainContent">
        <SpinnerLoader spinnerLoading={this.state.spinnerLoading} />
        {/* Tab bar */}
        <div className={"no-print"}>
          <ReportFilterMenu reports={reportTabs} activeReportId={selectedReport.reportId} handelTabsClick={this.handleTabsClick} />
        </div>

        {/* Conditionally render */}
        {selectedReport.reportId === "R0" && <TestsReviewCertification {...this.props} />}
        {selectedReport.reportId === "R1" && <OOSReview {...this.props} />}
        {selectedReport.reportId === "R2" && <BlueCardCertification />}
      </div>
    );
  }
}

const getApplicationlookupss = curdActions.getApplicationlookupss;
const getBlueCards = curdActions.getBlueCards;
let actionOptions = {
  create: false,
  update: false,
  read: true,
  delete: false,
  others: {
    getApplicationlookupss,
    getGroupReportLookup,
    getBlueCards: getBlueCards,
    getAllUsersList,
  },
};
let variables = {
  applicationlookupsReducer: { applicationlookupss: [] },
  diagnosticsReducer: {
    groupReportLookup: [],
  },
  BlueCardReducer: { BlueCards: [] },
  userReducer: {
    allUsers: [],
  },
};
const ReviewsCertificationsWrapperContainer = CRUDFunction(
  withRouter(ReviewsCertificationsWrapper),
  "ReviewsCertificationsWrapper",
  actionOptions,
  variables,
  ["applicationlookupsReducer", "diagnosticsReducer", "BlueCardReducer", "userReducer"],
  "testSchedule",
);

export default ReviewsCertificationsWrapperContainer;



// WEBPACK FOOTER //
// ./src/components/ReviewsCertifications/index.jsx